import { render, staticRenderFns } from "./BookingPositionRejected.vue?vue&type=template&id=68032156&scoped=true&"
import script from "./BookingPositionRejected.vue?vue&type=script&lang=js&"
export * from "./BookingPositionRejected.vue?vue&type=script&lang=js&"
import style0 from "./BookingPositionRejected.vue?vue&type=style&index=0&id=68032156&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68032156",
  null
  
)

export default component.exports